<template>
   <Html class="bg-primary">
      <ClientOnly>
         <NuxtLoadingIndicator :height="5" color="var(--color-secondary)" />
         <Notification />
      </ClientOnly>

      <Body>
         <PreviewDisclaimer />

         <div id="app-layout" class="flex flex-col">
            <Header />
            <main
               class="bg-light-grey pt-(--header-height) pb-(--footer-rounded-size) pb-20 md:pb-32"
            >
               <slot />
            </main>
            <Footer />
         </div>
      </Body>
   </Html>
</template>

<script lang="ts" setup>
const { t } = useI18n()

useSeo('', t('web.seo.layout.default.description'))
</script>
